export default __webpack_public_path__ + "static/media/important.bd5acfa5.svg";